import { AntDesign } from "@expo/vector-icons";
import {
  ProductThumbnail,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { Product } from "@towersystems/roam-common/lib/generated-types";
import {
  moneyToFormattedString,
  toTitleCase,
} from "@towersystems/roam-common/lib/shared-utils";
import { Spacings, TouchableOpacity, View } from "react-native-ui-lib";
import { Text } from "@towersystems/roam-common-native";
import React from "react";

export interface MainProductListItemProps {
  product: Product;
  onPress: () => void;
}
export const MainProductListItem = ({
  product,
  onPress,
}: MainProductListItemProps) => {
  const { colors } = useThemeProvider();

  const productOptionsString = React.useMemo(() => {
    const productOptions = product.options?.map((option) => {
      return option.name;
    });
    return productOptions?.join(", ");
  }, [product.options]);

  console.log(productOptionsString, product);
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
      }}
    >
      <View row centerV style={{ flexBasis: "100%", flexShrink: 1 }}>
        <View style={{ marginRight: Spacings.s4 }}>
          <ProductThumbnail size="large" imageUrl={product.image?.path} />
        </View>
        <View style={{ flexShrink: 1 }}>
          <View>
            <Text
              variant="heading"
              fontWeight="medium"
              numberOfLines={1}
              ellipsizeMode="head"
            >
              {toTitleCase(product.name)}
            </Text>
            {product.displayName ? (
              <Text color="subdued" variant="heading5">
                {product.displayName}
              </Text>
            ) : undefined}
            {
              <Text color="subdued" variant="heading5">
                {productOptionsString}
              </Text>
            }
          </View>
        </View>
      </View>
      <View style={{ paddingLeft: Spacings.s6 }} row centerV>
        <View style={{ alignItems: "flex-end" }}>
          <Text>{`${product.totalVariants} variants`}</Text>
        </View>
        <AntDesign
          style={[{ marginLeft: Spacings.s4 }]}
          name="right"
          size={24}
          color={colors.text}
        />
      </View>
    </TouchableOpacity>
  );
};
